import { getNormalizedUrl } from 'utils';
import { DEFAULT_AVATAR_IMAGE_URL } from 'utils/constants';

const getLogoImagePath = (uploadedLogoPath) => {
  if (uploadedLogoPath) {
    return getNormalizedUrl(uploadedLogoPath.filePath);
  }
  return DEFAULT_AVATAR_IMAGE_URL;
};

export const createDepartmentToAddObject = (values, uploadedLogoPath) => {
  const logoImagePath = getLogoImagePath(uploadedLogoPath);
  return {
    ...values,
    logo: logoImagePath,
    default: true,
  };
};

export const createDepartmentToEditObject = (values, uploadedLogoPath) => {
  const logo = uploadedLogoPath || DEFAULT_AVATAR_IMAGE_URL;

  return {
    ...values,
    type: 1,
    logo,
  };
};
